import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import { kindList, sortList, squidTypeList } from "@/utils/constant";
import { Link } from "react-router-dom";
import { getCardUrl } from "@/utils/utils";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Table,
    message,
    Row,
    Col,
    Card,
    Modal,
    Select,
    Button,
    InputNumber,
    Pagination,
    Spin,
    Empty,
} from "antd";
import HandDetail from "@/pages/commom/HandDetail";
import HandDetailOfc from "@/pages/commom/HandDetailOfc";

let kindListFilter = kindList.filter(
    (item) => item.value !== 3 && item.value !== 5
);

export default class TableRoundList extends React.Component {
    state = {
        loading: false, // 是否加载中
        detailLoading: false, // 手牌详情是否加载中
        show: false, // 是否显示手牌弹窗
        title: undefined, // 弹窗标题
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            sort_type: undefined,
            kind: undefined,
        },
        detailQueryParams: {
            // 详情查询参数
            page: 1,
            limit: 1,
            total: 0,
            mid: undefined,
            uid: undefined,
        },
        sortList: sortList, // 排序列表
        kindList: kindListFilter, // 游戏类型列表
        squidTypeList: squidTypeList, // 鱿鱼模式
        data: [], // 表格数据
        selectedData: {}, // 选中的表格数据
        handCardData: {}, // 手牌详情
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/get_match_list", {
                params: {
                    ...this.state.queryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 结束牌局
     */
    handleEndRound = ({ mid }) => {
        Modal.confirm({
            title: this.props.language["hint"],
            content: this.props.language["finishGambleConfirm"],
            onOk: () => {
                axios.post("/v1/api/close_match", { mid }).then((res) => {
                    if (res.code === 1) {
                        message.success(this.props.language["finishSuccessMessage"]);
                        this.fetchData();
                    }
                });
            },
        });
    };

    /**
     * 获取手牌详情数据
     */
    fetchHandCardData = () => {
        this.setState({ detailLoading: true });
        axios
            .get("/v1/api/union_game_detail", {
                params: {
                    ...this.state.detailQueryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        total: res.count || 0,
                    },
                    handCardData: res.data || {},
                });
            });
    };

    /**
     * 改变数据分页
     */
    hanldeChangePage = (pagination, type) => {
        if (type === "data") {
            // 数据分页
            this.setState(
                {
                    queryParams: {
                        ...this.state.queryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchData()
            );
        } else if (type === "handCard") {
            // 手牌详情数据
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchHandCardData()
            );
        }
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value, type) => {
        if (type === "handCard") {
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => this.fetchHandCardData()
            );
        } else {
            this.setState({
                queryParams: { ...this.state.queryParams, page: 1, [key]: value },
            });
        }
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    sort_type: undefined,
                    kind: undefined,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    /**
     * 显示弹窗
     */
    handleShow = (item) => {
        this.setState(
            {
                selectedData: item,
                show: true,
                title: this.props.language["handDetail"],
                handCardData: {},
                detailQueryParams: {
                    ...this.state.detailQueryParams,
                    page: 1,
                    mid: item.mid,
                    uid: undefined,
                },
            },
            () => this.fetchHandCardData()
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["sortPlaceholder"]}
                        value={this.state.queryParams.sort_type}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("sort_type", value)
                        }
                    >
                        {this.state.sortList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["gameTypePlaceholder"]}
                        value={this.state.queryParams.kind}
                        onChange={(value) => this.handleSetQueryParamsData("kind", value)}
                    >
                        {this.state.kindList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={(pagination) => this.hanldeChangePage(pagination, "data")}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["configId"]}
                            dataIndex="conf_id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleId"]}
                            dataIndex="mid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["createTime"]}
                            dataIndex=""
                            render={(item) =>
                                item.create_time
                                    ? moment(item.create_time * 1000).format(
                                        "YYYY-MM-DD HH:mm"
                                    )
                                    : 0
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleOpenTime"]}
                            dataIndex=""
                            render={(item) =>
                                item.start_time
                                    ? moment(item.start_time * 1000).format("YYYY-MM-DD HH:mm")
                                    : 0
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gamble"]}
                            dataIndex=""
                            render={(item) => item.name + " (MID:" + item.mid + ")"}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playMethod"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.kindList.find(
                                    (kindItem) => kindItem.value === item.game_kind
                                )
                                    ? this.state.kindList.find(
                                        (kindItem) => kindItem.value === item.game_kind
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["level"]}
                            dataIndex=""
                            render={(item) => {
                                if (
                                    item.game_kind === 1 ||
                                    item.game_kind === 4 ||
                                    item.game_kind === 8
                                ) {
                                    return (
                                        parseFloat((item.sb / 100).toFixed(2)) +
                                        "/" +
                                        parseFloat((item.bb / 100).toFixed(2)) +
                                        "(" +
                                        parseFloat((item.ante / 100).toFixed(2)) +
                                        ")"
                                    );
                                } else if (item.game_kind === 2) {
                                    return parseFloat((item.ante / 100).toFixed(2));
                                } else if (item.game_kind === 6) {
                                    return parseFloat((item.multiple / 100).toFixed(2));
                                }
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["squidGame"]}
                            dataIndex=""
                            render={(item) =>
                                item.squid_conf ? (
                                    <p>
                                        {this.state.squidTypeList.find(
                                            (item2) => item2.value === item.squid_conf.mode
                                        ) ?
                                            this.state.squidTypeList.find(
                                                (item2) => item2.value === item.squid_conf.mode
                                            ).label : ''}
                                        ({item.squid_conf.bb / 2}BB)
                                    </p>
                                ) : (
                                    this.props.language["no"]
                                )
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalHand"]}
                            dataIndex="total_hand"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleStatus"]}
                            dataIndex=""
                            render={(item) =>
                                item.start_time === 0
                                    ? this.props.language["notStart"]
                                    : this.props.language["started"]
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["currentPeopleNumber"]}
                            dataIndex=""
                            render={(item) => item.playing_num + "/" + item.seat_num}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={220}
                            render={(item) => (
                                <>
                                    <Button type="default" onClick={() => this.handleShow(item)}>
                                        {this.props.language["handDetail"]}
                                    </Button>
                                    <Button
                                        type="danger"
                                        className="ml10"
                                        ghost
                                        onClick={() => this.handleEndRound(item)}
                                    >
                                        {this.props.language["endGamble"]}
                                    </Button>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 牌局记录弹窗 */}
                <HandCardModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    loading={this.state.detailLoading}
                    pagination={{
                        showTotal: (total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                        showQuickJumper: true,
                        current: this.state.detailQueryParams.page,
                        pageSize: this.state.detailQueryParams.limit,
                        total: this.state.detailQueryParams.total,
                        size: isMobileDevice() ? 'small' : '',
                    }}
                    selectedData={this.state.selectedData}
                    handCardData={this.state.handCardData}
                    detailQueryParams={this.state.detailQueryParams}
                    handleSetQueryParamsData={this.handleSetQueryParamsData}
                    onCancel={() => this.setState({ show: false })}
                    onChange={(pagination) =>
                        this.hanldeChangePage({ current: pagination }, "handCard")
                    }
                />
            </div>
        );
    }
}

/**
 * 牌局记录弹窗
 */
class HandCardModal extends React.Component {
    render () {
        let handCardTitle = (
            <div className='container-header p0'>
                {this.props.handCardData.hand_time && (
                    <>
                        <span>{this.props.title}</span>
                        <span>（{this.props.handCardData.id}）</span>
                        <span className="mr20">
                            {this.props.handCardData.hand_time
                                ? this.props.handCardData.hand_time
                                : ""}
                        </span>
                    </>
                )}
                <InputNumber
                    precision={0}
                    min={0}
                    max={100000000}
                    placeholder={this.props.language["playerIdPlaceholder"]}
                    value={this.props.detailQueryParams.uid}
                    onChange={(value) =>
                        this.props.handleSetQueryParamsData("uid", value, "handCard")
                    }
                />
            </div>
        );

        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={handCardTitle}
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: this.props.type === "handCard" ? '60vh' : '70vh',
                    overflowY: "auto",
                }}
                footer={
                    <Pagination
                        {...this.props.pagination}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        onChange={this.props.onChange}
                    />
                }
            >
                <div className="container-content">
                    {/* 手牌详情 */}
                    <Spin spinning={this.props.loading}>
                        {this.props.handCardData.id && (
                            <>
                                {/* OFC */}
                                {this.props.selectedData.game_kind === 6 && (
                                    <HandDetailOfc
                                        {...this.props}
                                        handCardData={this.props.handCardData}
                                        searchPlayer={{
                                            uid1: this.props.detailQueryParams.uid,
                                        }}
                                    />
                                )}

                                {/* NLH, 6+, PLO, AOF */}
                                {this.props.selectedData.game_kind !== 6 && (
                                    <HandDetail
                                        {...this.props}
                                        handCardData={this.props.handCardData}
                                        squidConf={this.props.selectedData.squid_conf}
                                        searchPlayer={{
                                            uid1: this.props.detailQueryParams.uid,
                                        }}
                                    />
                                )}
                            </>
                        )}

                        {/* 暂无数据 */}
                        {!this.props.handCardData.id && (
                            <>
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            </>
                        )}
                    </Spin>
                </div>
            </Modal>
        );
    }
}
